// LIMITS
export const PROJECTS_LIMIT = 5000;

//PDFTron
export const PDFTRON_ADD_ACTION = 'add';
export const PDFTRON_MODIFY_ACTION = 'modify';
export const PDFTRON_DELETE_ACTION = 'delete';

// NOTIFICATIONS
export const DAY_MS = 86400000;

// AGENCIES
export const EMA = 'EMA';
export const FDA = 'FDA';
export const HEALTH_CANADA = 'Health Canada';
export const SWISSMEDIC = 'Swissmedic';
export const ALL_AGENCIES = [EMA, FDA, HEALTH_CANADA, SWISSMEDIC];

// DOCUMENT CATEGORIES
export const COMMITTEES_GROUPS = 'Committees & Groups';
export const DRUG_PACKAGES = 'Drug Packages';
export const GUIDELINES = 'Guidelines';
export const LABEL = 'Label';
export const MEETINGS_PRESENTATIONS = 'Meetings & Presentations';
export const PRESS_RELEASES = 'Press Releases';
export const RSS_FEEDS = 'RSS Feeds';
export const WARNING_LETTERS = 'Warning Letters';
export const WEBPAGES = 'Webpages';
export const ALL_DOCUMENT_CATEGORIES = [
  COMMITTEES_GROUPS,
  DRUG_PACKAGES,
  GUIDELINES,
  LABEL,
  MEETINGS_PRESENTATIONS,
  PRESS_RELEASES,
  RSS_FEEDS,
  WARNING_LETTERS,
  WEBPAGES,
];

// EXTRACT_DATA
export const SINGLE_PAGE = 'SINGLE_PAGE';
export const SINGLE_DOCUMENT = 'SINGLE_DOCUMENT';
export const ALL_DOCUMENTS = 'ALL_DOCUMENTS';
export const ALL_PRODUCTS = 'ALL_PRODUCTS'; // This has been removed for all future requests

export const ERROR_TYPES = {
  Unauthorized: 'Unauthorized',
};

export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// FILTERS
export const MODAL_FILTERS = {
  productName: {
    group: 'Products',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'product-name',
      label: 'Product Name',
      checkbox: true,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'productName',
      title: 'Top Products',
      xLabel: 'Product',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
  },

  brandName: {
    search: true,
    loading: false,
    selected: [],
    numPages: {
      id: 'brand-name',
      name: 'brandName',
      label: 'Brand Name',
      checkbox: false,
      visualize: false,
      options: [],
    },
  },
  productClass: {
    group: 'Products',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'product-class',
      label: 'Product Class',
      checkbox: true,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'productClass',
      title: 'Top Product Classes',
      xLabel: 'Product Class',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
    numProducts: {
      id: 'products-by-class',
      label: 'Products by Class',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'productClass',
      title: 'No. of Products by Class',
      xLabel: 'Product Class',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 10,
    },
  },
  companyName: {
    group: 'Products',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'company-name',
      label: 'Company Name',
      checkbox: true,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'companyName',
      title: 'Top Companies',
      xLabel: 'Company',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
    numProducts: {
      id: 'products-by-company-name',
      label: 'Products by Company',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'companyName',
      title: 'No. of Products by Company',
      xLabel: 'Company',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 10,
    },
  },
  productSubset: {
    group: 'Products',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'product-subset',
      name: 'productSubset',
      label: 'Product Subset',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  endpoint: {
    group: 'Products',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'endpoint',
      label: 'Endpoint',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'endpoint',
      title: 'Top Endpoints',
      xLabel: 'Endpoint',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
    numProducts: {
      id: 'products-by-endpoint',
      label: 'Products by Endpoint',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'endpoint',
      title: 'No. of Products by Endpoint',
      xLabel: 'Endpoint',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 10,
    },
  },
  manufacturingSite: {
    group: 'Products',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'manufacturing-site',
      label: 'Manufacturing Site',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'manufacturingSite',
      title: 'Top Manufacturing Sites',
      xLabel: 'Manufacturing Site',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
    numProducts: {
      id: 'products-by-manufacturing-site',
      label: 'Products by Manufacturing Site',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'manufacturingSite',
      title: 'No. of Products by Manufacturing Site',
      xLabel: 'Manufacturing Site',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 10,
    },
  },
  productType: {
    group: 'Products',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'product-type',
      name: 'productType',
      label: 'Product Type',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  biomarker: {
    group: 'Biomarkers',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'biomarker',
      name: 'biomarker',
      label: 'Biomarker',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  therapeuticArea: {
    group: 'Medical Conditions',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'therapeutic-area',
      label: 'Therapeutic Area',
      checkbox: true,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'therapeuticArea',
      title: 'Top Therapeutic Areas',
      xLabel: 'Therapeutic Area',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
    numProducts: {
      id: 'products-by-therapeutic-area',
      label: 'Products by Therapeutic Area',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'therapeuticArea',
      title: 'No. of Products by Therapeutic Area',
      xLabel: 'Therapeutic Area',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 10,
    },
  },
  indication: {
    group: 'Medical Conditions',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'indication',
      label: 'May Treat/Prevent',
      checkbox: true,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'indication',
      title: 'Top Indications',
      xLabel: 'Indication',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 10,
    },
    numProducts: {
      id: 'products-by-indication',
      label: 'Products by Indication / Off-Label Use',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'indication',
      title: 'No. of Products by Indication',
      xLabel: 'Indication',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 10,
    },
  },
  contraIndication: {
    group: 'Medical Conditions',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'contraindication',
      name: 'contraIndication',
      label: 'Contraindication',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  biomarkerCategory: {
    group: 'Biomarkers',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'biomarker-category',
      name: 'biomarkerCategory',
      label: 'Biomarker Category',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  drugDesignationOrProgram: {
    group: 'Regulatory Process',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'drug-designation-or-program',
      name: 'drugDesignationOrProgram',
      label: 'Drug Designation / Program',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  applicationType: {
    group: 'Regulatory Process',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'application-type',
      name: 'applicationType',
      label: 'Application Type',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  docSubCategory: {
    group: 'Regulatory Process',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'approval-type',
      name: 'docSubCategory',
      label: 'Approval Type',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  submissionType: {
    group: 'Regulatory Process',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'submission-type',
      name: 'submissionType',
      label: 'Submission Type',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  docCategory: {
    group: 'Documents',
    search: false,
    loading: true,
    selected: ['Review Package', 'Label'],
    numPages: {
      id: 'document-category',
      name: 'docCategory',
      label: 'Document Category',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  docType: {
    group: 'Documents',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'document-type',
      name: 'docType',
      label: 'Document Type',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  guidanceTopic: {
    group: 'Documents',
    search: true,
    loading: true,
    selected: [],
    numPages: {
      id: 'guidance-topic',
      name: 'guidanceTopic',
      label: 'Guidance Topic',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  guidanceStatus: {
    group: 'Documents',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'guidance-status',
      name: 'guidanceStatus',
      label: 'Guidance Status',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  regAgency: {
    group: 'Agencies',
    search: false,
    loading: true,
    selected: ['FDA'],
    numPages: {
      id: 'agency',
      name: 'regAgency',
      label: 'Agency',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  regAgencyDivision: {
    group: 'Agencies',
    search: false,
    loading: true,
    selected: [],
    numPages: {
      id: 'agency-division',
      name: 'regAgencyDivision',
      label: 'Agency Division/Office',
      checkbox: true,
      visualize: false,
      options: [],
    },
  },
  timeline: {
    search: false,
    loading: true,
    selected: [],
    type: 'timeline',
    numPages: {
      id: 'timeline',
      label: 'Timeline',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'timeline',
      title: 'Database Content over Time',
      xLabel: 'Year',
      yLabel: '% of Matched Results',
      yDataType: 'float',
      yDataPerc: true,
      asTable: false,
      numTopOptions: 25,
    },
    numProducts: {
      id: 'products-timeline',
      label: 'Products Timeline',
      checkbox: false,
      visualize: true,
      options: [],
      visualizeOptions: [],
      name: 'timeline',
      title: 'No. of Products over Time',
      xLabel: 'Year',
      yLabel: 'No. of Products',
      yDataType: 'int',
      yDataPerc: false,
      asTable: false,
      numTopOptions: 25,
    },
  },
};
